import TradeCard from "./TradeCard";
import DemoCard from "./DemoCard";

export const CardRegistry = {
  SAUDAPRO: TradeCard,
  BOLTTRAD: TradeCard,
  ARROWTRAD: TradeCard,
  TRADO: TradeCard,
  ATMSTOX: TradeCard,
  DEMO: DemoCard,
  DEFAULT: TradeCard,
};
